export default function modifyDateForDate(date: Date, value: number) {
  const temp = new Date(date);
  temp.setDate(value);
  return new Date(temp);
}
